import { Component, ViewEncapsulation } from '@angular/core'
import { TranslateService } from '@ngx-translate/core'

@Component({
  selector: 'flowaccount-google-workspace-start-business',
  templateUrl: './google-workspace-start-business.component.html',
  styleUrl: './google-workspace-start-business.component.scss',
  encapsulation: ViewEncapsulation.None,
})
export class GoogleWorkspaceStartBusinessComponent {
  public currentSlide = 1
  public mockContent: object[]
  constructor(public translate: TranslateService) {}
  ngOnInit() {
    this.showMockContent()
  }
  goToSlide(slideNo: number) {
    this.currentSlide = slideNo
  }
  showMockContent() {
    const lang = this.translate.currentLang
    const baseUrl = 'https://flowaccountcdn.com/new_landing/image/google-workspace/start-business'
    const text = 'GOOGLE_WORKSPACE.START_BUSINESS'

    this.mockContent = [
      {
        navigation: `${text}.1.NAVIGATION`,
        image: `${baseUrl}/discover.png`,
        imageMock: `${baseUrl}/discover_mock.png`,
        vdo: `${baseUrl}/discover.mp4`,
        title: `${text}.1.TITLE`,
        detail: `${text}.1.DETAIL`,
        link: `https://form.flowaccount.com/googleworkspace`,
      },
      {
        navigation: `${text}.2.NAVIGATION`,
        image: `${baseUrl}/price.png`,
        imageMock: `${baseUrl}/price_mock.png`,
        vdo: `${baseUrl}/price.mp4`,
        title: `${text}.2.TITLE`,
        contentHtml: `${text}.2.HTML`,
        textUnder: `${text}.2.TEXT_UNDER`,
        id: 'idGoogleWorkspaceProductivity',
      },
      {
        navigation: `${text}.3.NAVIGATION`,
        image: `${baseUrl}/benefit_flowaccount.png`,
        imageMock: `${baseUrl}/benefit_flowaccount_mock.png`,
        vdo: `${baseUrl}/benefit_flowaccount.mp4`,
        title: `${text}.3.TITLE`,
        detail: `${text}.3.DETAIL`,
        link: `https://auth.flowaccount.com/${lang}/Account/Register`,
      },
    ]
  }

  loopArray(no: number) {
    return new Array(no)
  }
  scrollToTarget(targetId: string) {
    const targetElement = document.getElementById(targetId)
    if (targetElement) {
      const offset = targetElement.offsetTop - 10
      window.scrollTo({
        top: offset,
        behavior: 'smooth',
      })
    }
  }
}
